import { Link } from "react-router-dom";
import CryptoIcon from "components/Secondary/CryptoIcon";
import { TVChartContainer } from "components/TVChartContainer";
import { formatNumber } from "helpers/helpers";
import useWindowDimensions from "helpers/screen";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { fetchOpenOrders } from "ts/accountInfo/openOrders";
import { fetchUserAccounts } from "ts/accountInfo/tokens";
import { crank } from "utils/crank";
import { GetOpenOrdersAll } from "utils/market";
import { cancelOrders, settleFundsCustom } from "utils/order";
import { GetRecentTrades } from "utils/orderbook";
import RecentTradeRow from "./recentTradeRow";
import "./style.scss";
import { accounts, clearQueue, setOpenOrders} from "redux/state";
import { useDispatch, useSelector } from "react-redux";

const mockH = { // mockHistory
  time: "4/25/2022, 05:02:32 PM",
  side: "buy",
  type: "Limit",
  size: 1.30,
  sizeUSD: 103.24,
  filledSize: 1.29,
  fillPrice: 103.24,
  price: 103.24,
  filledValue:102.25,
  status: "Open"
}


const OpenOrdersBox = ({marketData, updateMarket, eventsQueue}) => {

  const [page, setPage] = useState(2);
  const {width} = useWindowDimensions();
  const state = useSelector((state) => state.storage);
  const dispatch = useDispatch();
  const [openOrdersList, setOpenOrdersList] = useState([]);
  const [toSettle, setToSettle] = useState([]);
  const [openOrdersLoaded, setOpenOrdersLoaded] = useState(false);
  const [unsettledFunds, setUnsettledFunds] = useState(false);

  const [recentTrades, setRecentTrades] = useState([]);
  const [buyDemand, setBuyDemand] = useState(0);
  const [sellDemand, setSellDemand] = useState(0);

  const [socket, setSocket] = useState(null);
  const [socketConnected, setSocketConnected] = useState(false);
  
  useEffect(() => {
    console.log("DONE");
    let openOrdersToSettle = state.openOrders
      .filter(oo => oo.baseTokenFree.toNumber() > 0 || oo.quoteTokenFree.toNumber() > 0)
      .map(oo => {
        let marketInfo = state.markets.find(m => m.market == oo.market.toBase58());
        if (!marketInfo) {
          console.log("Error, No market found for " +  oo.market.toBase58());
          return null;
        }
        return {
          address: oo.address.toBase58(),
          market: oo.market.toBase58(),
          base: oo.baseTokenFree.toNumber() / 10 ** marketInfo.baseToken.decimals,
          quote: oo.quoteTokenFree.toNumber() / 10 ** marketInfo.quoteToken.decimals,
          baseMint: oo.base,
          quoteMint: oo.quote,
          marketName: marketInfo.baseToken.symbol + "-" + marketInfo.quoteToken.symbol,
          object: oo,
        }
      }).filter(x => x != null);
    setToSettle([ ...openOrdersToSettle]);
  }, [state.openOrders])
  
  function closeOrders(orders) {
    cancelOrders(state.connection, state.wallet, orders).then((obj) => {
      console.log("[LOG] Order cancel result, re-fetching open orders");
      // toast.loading("Settling Funds...", {
      //   id: "order"
      // })
      GetOpenOrdersAll(state).then(
        orders => {
          console.log("User Open Orders:", orders)
          setOpenOrdersList(orders);
          setOpenOrdersLoaded(true);
          Promise.all([
            fetchUserAccounts(state),
            fetchOpenOrders(state),
          ]).then(res => {
            dispatch(accounts(res[0]));
            dispatch(setOpenOrders(res[1]));
          })
          // settleFunds(state.connection, order.loadedMarket, state.accounts, state.wallet, "order").then(() => {
          //   console.log("Settle funds result")
          //   Promise.all([
          //     fetchUserAccounts(state),
          //     fetchOpenOrders(state),
          //   ]).then(res => {
          //     dispatch({type: "accounts", accounts: res[0]});
          //     dispatch({type: "openOrders", openOrders: res[1]});
          //   })
          // })
        }
      )
    })
  }

  useEffect(() => {
    const ws = new WebSocket(
      `wss://public-api.birdeye.so/socket?x-api-key=${process.env.REACT_APP_CANDLESTICK_API_KEY}`,
      'echo-protocol'
    )

    ws.onopen = () => {
        console.log('WebSocket connected');
        setSocketConnected(true);
    };

    ws.onmessage = (event) => {
      let data = JSON.parse(event.data)
      if(data.type !== "TXS_DATA") return;
      data = data.data;
      if(data.from.address === marketData.pairs.base.address || data.to.address === marketData.pairs.base.address) {
        data.lastReceived = new Date().getTime();
        setRecentTrades((old) => [data, ...old]);
        if(data.volumeUSD) {
          if(data.side === "buy") {
            setBuyDemand((old) => old + data.volumeUSD);
          } else
            setSellDemand((old) => old + data.volumeUSD);
        }
      }
      // console.log("TRADE ALERT", recentTrades);
    };

    ws.onclose = () => {
        console.log('WebSocket disconnected');
        setSocketConnected(false);
    };
    setSocket(ws);
    return () => {
        ws.close();
    };
    
  }, []);

  useEffect(() => {
    if(socketConnected && marketData.pairs) {
      console.log("REE", marketData.pairs.base.address, socket.connected)
      GetRecentTrades(marketData.pairs.base.address).then(res => setRecentTrades(res));
      if(socketConnected) {
        let msg = {
          type: "SUBSCRIBE_TXS",
          data: {
            address: marketData.pairs.base.address
          }
        }
        socket.send(JSON.stringify(msg))
      }
    }
    return () => {
      if(socket && socket.readyState === WebSocket.OPEN) socket.send(JSON.stringify({type: "UNSUBSCRIBE_TXS"}));
    }
  }, [socketConnected, marketData]);

  // useEffect(() => {
  //   if(marketData.pairs) {
  //     const _socket = new WebSocket(
  //       `wss://public-api.birdeye.so/socket?x-api-key=${process.env.REACT_APP_CANDLESTICK_API_KEY}`,
  //       'echo-protocol'
  //     )
  //     _socket.addEventListener('message', tradesListener);
  //     setSocket(_socket)
      
  //     let baseToken = marketData.pairs.base.address;
  //     let msg = {
  //       type: "SUBSCRIBE_TXS",
  //       data: {
  //         address: baseToken
  //       }
  //     }
  //     return () => {
  //       socket.removeEventListener('message', tradesListener);
  //       socket.close();
  //     }
  //   }

  //   return () => {
  //     socket.send(JSON.stringify({type: "UNSUBSCRIBE_TXS"}));
  //   }
  // }, [marketData])


  useEffect(() => {
    if(marketData.serumMarket) {
      console.log("MAJOR QUE ALERT", state.queue)
      let refreshToggled = false;
      let refreshEvent = null
      for(let i = 0; i < state.queue.length; i++) {
        if(state.queue[i].type === "order") {
          refreshToggled = true;
          refreshEvent = state.queue[i];
        }
      }
      if(refreshToggled) {
        console.log("Refresh event detected!", state.queue)
        GetOpenOrdersAll(state).then(
          orders => {
            setOpenOrdersList(orders);
            dispatch(clearQueue(refreshEvent.id));
          }
        )
      }
    }
  },[state.queue, marketData])

  function trySettleFunds(toSettle) {
    settleFundsCustom(state.connection, state.accounts, toSettle, state.wallet, 1).then(() => {
      console.log("Settle funds result")
      Promise.all([
        fetchUserAccounts(state),
        fetchOpenOrders(state),
      ]).then(res => {
        dispatch(accounts(res[0]));
        dispatch(setOpenOrders(res[1]));
      })
    })
  }

  function tryCrank() {
    crank(state.connection, state.wallet, marketData.serumMarket, eventsQueue);
  }

  useEffect(() => {
    if(state.walletConnected && marketData.serumMarket && state.publicKey)
      GetOpenOrdersAll(state).then(
        orders => {
          console.log("User Open Orders:", orders)
          setOpenOrdersList(orders);
          setOpenOrdersLoaded(true);
        }
      )
  },[marketData, state.publicKey, state.walletConnected, state.openOrders]);

  useEffect(() => { // Check if user needs to settle funds every 7 seconds
    async function checkSettleFunds() {
      if (!state.wallet || !state.wallet.publicKey) return;
      let hasUnsettled = false;
      for (let openOrdersAccount of await marketData.serumMarket.findOpenOrdersAccountsForOwner(
        state.connection,
        state.wallet.publicKey,
      )) {
        if (openOrdersAccount.baseTokenFree.toNumber() > 0 || openOrdersAccount.quoteTokenFree.toNumber() > 0) {
          hasUnsettled = true;
        } 
      }
      setUnsettledFunds(hasUnsettled);
    }
    
    let interval = setInterval(checkSettleFunds, 7000);

    return () => clearInterval(interval);
  }, [state.wallet, marketData]);

  

  
  if(width > 768)
  return <div className="openOrdersBox">
    <div className="topBar disable-select">
      <div className={page === 0 ? "button selected" : "button"} onClick={() => setPage(0)}>
        Open Orders
        {
          openOrdersList && openOrdersList.length > 0 && 
          <p className="placedOrders">{openOrdersList.length}</p>
        }
      </div>
      {/* <div className={page === 1 ? "button selected" : "button"} onClick={() => setPage(1)}>
        Order History
      </div> */}
      <div className={page === 2 ? "button selected" : "button"} onClick={() => setPage(2)}>
        <div className="buttonInner">
          <p>Recent Orders</p>
          {/* <p className="blink">LIVE</p> */}
        </div>
      </div>
      <div className={page === 3 ? "button selected" : "button"} onClick={() => setPage(3)}>
        <p>Settle Funds</p>
        {
          toSettle && toSettle.length > 0 && 
          <p className="unsettledFunds">{toSettle.length}</p>
        }
      </div>
      <div className={page === 4 ? "button selected" : "button"} onClick={() => setPage(4)}>
        <p>Supply / Demand</p>
      </div>
      { eventsQueue.length > 0 &&
      <div className={page === 5 ? "button selected" : "button"} onClick={() => tryCrank()}>
        {"Crank Event Queue (" + eventsQueue.length + ")"}
      </div> }
    </div>

    {
      page === 0 &&
      <>
        <div className="sorter" style={{gridTemplateColumns: "17% 17% 17% 17% 16% 16%"}}>
          <p>Market</p>
          <p>Side</p>
          <p>Size</p>
          <p>Price</p>
          <p>Filled</p>
          <p className="unsettledFunds claimAllButton" onClick={() => closeOrders(openOrdersList)}>Close All</p>
        </div>

        <div className="openOrdersTable">
          { openOrdersLoaded ?
            openOrdersList.map((item, i) => {
              return <div key={i} className="item" style={{gridTemplateColumns: "17% 17% 17% 17% 16% 16%"}}>
                <Link to={"/?trade=" + item.marketName} className="menuItem">
                {/* <a href={"https://pro.prism.ag/?trade=" + item.marketName} className="menuItem"> */}
                  <CryptoIcon symbol= {item.marketName.split("-")[1]} size={15}/>
                  <CryptoIcon symbol= {item.marketName.split("-")[0]} size={25}/>
                  <p>{item.marketName}</p>
                </Link>
                <p className={item.side === "buy" ? "side green" : "side red"}>{item.side.toUpperCase()}</p>
                <p>{formatNumber(item.size, "auto")}</p>
                <p>{formatNumber(item.price, "auto")}</p>
                <p>{item.fill ? formatNumber(item.fill.size, "auto") : 0} / {formatNumber(item.size, "auto") }</p>
                <div className="closeOrder disable-select">
                  <div className="closeOrderButton" onClick={() => closeOrders([item])}>Close</div>
                </div>
              </div>
            })
            :
            state.walletConnected ?
            <div className="loadingOrders">
              <p>Loading Open Orders</p>
            </div>
            :
            <div className="loadingOrders">
              <p>No Open Orders</p>
            </div>
          }
          
        </div>
      </>
    }
    {
      page === 1 &&
      <>
        <div className="historySorter">
          <p>Time</p>
          <p>Side</p>
          <p>Type</p>
          <p>Filled Size / Order Size</p>
          <p>Avg Fill Price</p>
          <p>Price</p>
          <p>Filled Value / Order Value</p>
          <p>Status</p>
        </div>

        <div className="orderHistoryTable">
          {
            [mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH].map((item, i) => {
              return <div key={i} className="item">
                <p>{item.time}</p>
                <p className={item.side === "buy" ? "side green" : "side red"}>{item.side.toUpperCase()}</p>
                <p>{item.type}</p>
                <p>{item.filledSize} / {item.size}</p>
                <p>{item.fillPrice}</p>
                <p>{item.price}</p>
                <p>{item.filledValue} / {item.sizeUSD} </p>
                <p>{item.status}</p>
              </div>
            })
          }
          
        </div>
      </>
    }
    { // Recent Orders
      page === 2 &&
      <>
        <div className="recentOrdersSorter">
          <p>Side</p>
          <p>Time</p>
          <p>Price</p>
          <p>Value</p>
          <p style={{textAlign:"center"}}>Tokens Traded</p>
          <p>By</p>
          <p style={{textAlign:"center"}}>Tx</p>
        </div>

        
          <div className="recentTradesTable">
            { recentTrades ?
              recentTrades.map((item, i) => {
                if(i < 50)
                return <RecentTradeRow key={i} rowId={i} item={item}/>
              })
              :
              <div className="loadingOrders">
                <p>Recent trades will show up here.</p>
              </div>
            }
          </div>
        
      </>
    }
     {
      page === 3 &&
      <>
        <div className="sorter">
          <p>Market</p>
          <p>Market Address</p>
          <p>Quote Tokens Claimable</p>
          <p>Base Tokens Claimable</p>
          <p className="unsettledFunds settleAllButton"  onClick={() => trySettleFunds(toSettle)}>Settle All</p>
        </div>

        <div className="openOrdersTable">
        { toSettle.map((item, i) => {
              return <div key={i} className="item">
                <Link to={"/?trade=" + item.marketName} className="menuItem">
                {/* <a href={"https://pro.prism.ag/?trade=" + item.marketName} className="menuItem"> */}
                  <CryptoIcon symbol= {item.marketName.split("-")[1]} size={15}/>
                  <CryptoIcon symbol= {item.marketName.split("-")[0]} size={25}/>
                  <p>{item.marketName}</p>
                </Link>
                {/* </a> */}
                <a href={"https://solscan.io/account/" + item.market} >
                  {item.market.slice(0, 5) + "..." + item.market.slice(item.market.length-5, item.market.length)}
                </a>
                <p>{formatNumber(item.base, "auto")  + " " + item.marketName.split("-")[0]}</p>
                <p>{formatNumber(item.quote, "auto") + " " + item.marketName.split("-")[1]}</p>
                <div className="closeOrder disable-select" onClick={() => trySettleFunds([item])}>
                  <div className="settleButton">Settle</div>
                </div>
              </div>
            })
          }
        </div>
      </>
    }
    {
      page === 4 &&
      <>
        <div className="supplyDemand">
          <div className="supplyDemandInner">
            <div className="side">
              <p className="label">SOLD</p>
              <p className="value" style={{color:"var(--red700)"}}>${formatNumber(sellDemand, 1)}</p>
            </div>
            <div className="side">
              <p className="label">BOUGHT</p>
              <p className="value" style={{color:"var(--green700)"}}>${formatNumber(buyDemand, 1)}</p>
            </div>
          </div>
          <div className="progressBar">
            <div className="progressBarInner" style={{backgroundColor:"var(--red700)",width: (sellDemand / (buyDemand + sellDemand)) * 50 + "%"}}></div>
            <div className="progressBarInner" style={{backgroundColor:"var(--green700)",width: (buyDemand / (buyDemand + sellDemand)) * 50 + "%"}}></div>
          </div>
          <button className="resetView" onClick={() => {setBuyDemand(0); setSellDemand(0)}}>Reset</button>
        </div>
      </>
    }
    
  </div>

  if(width <= 768)
  return <div className="openOrdersBoxMobile">
    <div className="topBar disable-select">
      <div className={page === 0 ? "button selected" : "button"} onClick={() => setPage(0)}>
        Open Orders
        {
          openOrdersList && openOrdersList.length > 0 && 
          <p className="placedOrders">{openOrdersList.length}</p>
        }
      </div>
      {/* <div className={page === 1 ? "button selected" : "button"} onClick={() => setPage(1)}>
        Order History
      </div> */}
      <div className={page === 2 ? "button selected" : "button"} onClick={() => setPage(2)}>
        Chart
      </div>
      <div className={page === 3 ? "button selected" : "button"} onClick={() => setPage(3)}>
        <p>Settle Funds</p>
        {
          toSettle && toSettle.length > 0 && 
          <p className="unsettledFunds">{toSettle.length}</p>
        }
      </div>
      {eventsQueue.length > 0 && 
      <div className={page === 4 ? "button selected" : "button"} onClick={() => tryCrank()}>
        {"Crank (" + eventsQueue.length + ")"}
      </div> }
    </div>

    {
      page === 0 &&
      <>
        <div className="sorter" style={{gridTemplateColumns: "17% 17% 17% 17% 16% 16%"}}>
          <p>Market</p>
          <p>Side</p>
          <p>Size</p>
          <p>Price</p>
          <p>Filled</p>
          <p className="greenButton" onClick={() => closeOrders(openOrdersList)}>Close All</p>
        </div>

        <div className="openOrdersTable">
        { openOrdersLoaded ?
            openOrdersList.map((item, i) => {
              return <div key={i} className="item" style={{gridTemplateColumns: "17% 17% 17% 17% 16% 16%"}}>
                <Link to={"/?trade=" + item.marketName} className="menuItem">
                {/* <a href={"https://pro.prism.ag/?trade=" + item.marketName} className="menuItem"> */}
                  {/* <CryptoIcon symbol= {item.marketName.split("-")[1]} size={15}/>
                  <CryptoIcon symbol= {item.marketName.split("-")[0]} size={25}/> */}
                  <p>{item.marketName}</p>
                </Link>
                <p className={item.side === "buy" ? "side green" : "side red"}>{item.side.toUpperCase()}</p>
                <p>{item.size}</p>
                <p>{item.price}</p>
                <p>{item.fill ? item.fill.size : 0} / {item.size}</p>
                <div className="closeOrder disable-select" onClick={() => closeOrders([item])}>
                  <div className="redButton">Close</div>
                </div>
              </div>
            })
            :
            state.walletConnected ?
            <div className="loadingOrders">
              <p>Loading Open Orders</p>
            </div>
            :
            <div className="loadingOrders">
              <p>No Open Orders</p>
            </div>
          }
        </div>
      </>
    }
    {
      page === 1 &&
      <>
        <div className="historySorter">
          <p>Time</p>
          <p>Side</p>
          <p>Type</p>
          <p>Filled Size / Order Size</p>
          <p>Avg Fill Price</p>
          <p>Price</p>
          <p>Filled Value / Order Value</p>
          <p>Status</p>
        </div>

        <div className="orderHistoryTable">
          {
            [mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH,mockH].map((item, i) => {
              return <div key={i} className="item">
                <p>{item.time}</p>
                <p className={item.side === "buy" ? "side green" : "side red"}>{item.side.toUpperCase()}</p>
                <p>{item.type}</p>
                <p>{item.filledSize} / {item.size}</p>
                <p>{item.fillPrice}</p>
                <p>{item.price}</p>
                <p>{item.filledValue} / {item.sizeUSD} </p>
                <p>{item.status}</p>
              </div>
            })
          }
          
        </div>
      </>
    }

    {
      page === 2 &&
      <div className="tvChartMobile">
        <TVChartContainer marketData={marketData}/>
      </div>
    }

    {
      page === 3 &&
      <>
      <div className="sorter">
          <p>Market</p>
          <p>Market Address</p>
          <p>Quote Available</p>
          <p>Base Available</p>
          <p className="greenButton"  onClick={() => trySettleFunds(toSettle)}>Settle All</p>
        </div>

        <div className="openOrdersTable">
        { toSettle.map((item, i) => {
              return <div key={i} className="item">
                <Link to={"/?trade=" + item.marketName} className="menuItem">
                {/* <a href={"https://pro.prism.ag/?trade=" + item.marketName} className="menuItem"> */}
                  {/* <CryptoIcon symbol= {item.marketName.split("-")[1]} size={15}/>
                  <CryptoIcon symbol= {item.marketName.split("-")[0]} size={25}/> */}
                  <p>{item.marketName}</p>
                </Link>
                {/* </a> */}
                <a href={"https://solscan.io/account/" + item.market} >
                  {item.market.slice(0, 5) + "..." + item.market.slice(item.market.length-5, item.market.length)}
                </a>
                <p>{item.base + " " + item.marketName.split("-")[0]}</p>
                <p>{item.quote + " " + item.marketName.split("-")[1]}</p>
                <div className="closeOrder disable-select" onClick={() => trySettleFunds([item])}>
                  <div className="greenButton">Settle</div>
                </div>
              </div>
            })
          }
        </div>
    </>
    }
    
  </div>
}

export default OpenOrdersBox;

